// ABOUTME: The one place a submitted Kratos form body takes the SDK's request type.
// ABOUTME: FlowForm posts exactly the fields the flow's UI nodes declared, so the shape is the server's.

/**
 * FlowForm builds the body from the flow's own `ui.nodes` (buildFlowBody), so the
 * fields and their `method` are whatever Kratos asked for — the SDK's Update*FlowBody
 * union describes the same thing from the other side. This is the single assertion
 * that says so; pages pass it straight to the matching `ory.update*Flow` call.
 */
export const asFlowBody = <TBody extends object>(body: Record<string, unknown>): TBody => body as TBody
